module.exports = __webpack_public_path__ + "img/image104.ab2f3a77.png";